import React from "react";
import lazyPage from "../../../common/helpers/lazyPage";
import PageLoader from "../../components/PageLoader";

export default lazyPage(
    "src/front/pages/game-admin/GameAdmin.tsx",
    () => import("./GameAdmin"),
    <PageLoader />,
);
